import type { GalleryModalWrapperProps } from "./gallery-modal.type";

import { Modal } from "antd";

import { GalleryModal } from "./gallery-modal.component";
import { GALLERY_MODAL_STYLES } from "./gallery-modal.constant";
import { useGalleryModalOpen } from "./gallery-modal.hook";

import "./gallery-modal.style.less";

export const GalleryModalWrapper = <Data = unknown,>({
  items,
  defaultOpen,
  defaultCurrentSlide,
  onClose,
}: GalleryModalWrapperProps<Data>) => {
  const { open, closeModal } = useGalleryModalOpen({ defaultOpen, onClose });

  return (
    <Modal
      open={open}
      width="100vw"
      footer={null}
      mask={{ closable: false }}
      className="gallery-modal"
      styles={GALLERY_MODAL_STYLES}
      onCancel={closeModal}
      destroyOnHidden
    >
      <GalleryModal
        items={items}
        defaultCurrentSlide={defaultCurrentSlide}
        onCloseClick={closeModal}
      />
    </Modal>
  );
};
